import { useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

const VAPID_PUBLIC_KEY =
  'BF6n0_Ur2wbGdoXNblERjcLJQ0KKPfqrsHLyljPo6FRpZO8usaiGSnqEwy3dY5N19ojk6Dt-EdCvTzmTVUtfe9k';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);

  return Uint8Array.from(
    [...rawData].map((char) => char.charCodeAt(0))
  );
}

const PushNotifications = () => {
  useEffect(() => {
    const registerPush = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          console.log('Web Push: no hay sesión autenticada');
          return;
        }

        if (!('serviceWorker' in navigator)) {
          console.log('Web Push: Service Worker no disponible');
          return;
        }

        if (!('PushManager' in window)) {
          console.log('Web Push: PushManager no disponible');
          return;
        }

        if (!('Notification' in window)) {
          console.log('Web Push: Notification API no disponible');
          return;
        }

        const registration =
          await navigator.serviceWorker.register(
            '/service-worker.js',
            { scope: '/' }
          );

        console.log(
          'Web Push: Service Worker registrado',
          registration.scope
        );

        let permission = Notification.permission;

        if (permission === 'default') {
          permission = await Notification.requestPermission();
        }

        if (permission !== 'granted') {
          console.log(
            'Web Push: permiso de notificaciones no concedido'
          );
          return;
        }

        let subscription =
          await registration.pushManager.getSubscription();

        if (!subscription) {
          subscription =
            await registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey:
                urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
            });
        }

        await axios.post(
          `${API}/notifications/push/subscribe`,
          {
            subscription: subscription.toJSON()
          }
        );

        console.log(
          'Web Push: dispositivo registrado correctamente'
        );
      } catch (error) {
        console.error(
          'Web Push: error registrando dispositivo',
          error
        );
      }
    };

    registerPush();
  }, []);

  return null;
};

export default PushNotifications;
